module.exports = __webpack_public_path__ + "static/img/map.0ee6b30.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/map.png
// module id = gjRl
// module chunks = 1